import { createItemStorage } from "./createItemStorage";

export const trial = ({ storage }) => createItemStorage(storage, "trial");
